import { OrderDetailsService } from './../shared/services/order-details/order-details.service';
import { map } from 'rxjs/internal/operators';
import { LoginService } from './../shared/services/login/login.service';
import { ResponseValidator } from '../shared/utils/response-validator';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/order-details/order-details.service";
import * as i2 from "../shared/services/login/login.service";
var OrdersResolver = /** @class */ (function () {
    function OrdersResolver(_order, _auth) {
        this._order = _order;
        this._auth = _auth;
    }
    OrdersResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var user = this._auth.userData;
        if (user.authenticated && (user.rxTied || user.caregivee)) {
            return this._order.get(user).pipe(map(function (data) {
                if (new ResponseValidator(data, true)) {
                    return _this._order.viewOrdersData;
                }
                else {
                    data.hasError = true;
                }
                return data;
            }, function (err) { return err; }));
        }
    };
    OrdersResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OrdersResolver_Factory() { return new OrdersResolver(i0.ɵɵinject(i1.OrderDetailsService), i0.ɵɵinject(i2.LoginService)); }, token: OrdersResolver, providedIn: "root" });
    return OrdersResolver;
}());
export { OrdersResolver };
